import { IntakeLabelCollection } from '../../entities/intake-label.interface';
import { ProgramList } from '../../constants/program-list';
const aishName = ProgramList.aish;
const adapName = ProgramList.adap;
const incomeSupportName = ProgramList.incomeSupport;

export const AishSpouseLabels: IntakeLabelCollection = {
  firstName: {
    label: 'First name',
    replacementLabel: "<<replacementLabel>>'s first name",
  },
  middleName: {
    label: 'Middle name',
    replacementLabel: "<<replacementLabel>>'s middle name",
  },
  lastName: {
    label: 'Last name',
    replacementLabel: "<<replacementLabel>>'s last name",
  },
  birthdate: {
    label: 'Birthdate',
    replacementLabel: "<<replacementLabel>>'s birthdate",
  },
  preferredName: {
    label: 'Other preferred first name',
    replacementLabel: "<<replacementLabel>>'s other preferred first name",
  },
  birthCertificateLastName: {
    label: 'Last name on birth certificate',
    replacementLabel: "<<replacementLabel>>'s last name on birth certificate",
  },
  gender: {
    label: 'Gender',
    replacementLabel: "<<replacementLabel>>'s gender",
  },
  socialInsuranceNumber: {
    label: 'Social Insurance Number',
    replacementLabel: "<<replacementLabel>>'s Social Insurance Number",
  },
  isReceivingAISH: {
    label: `Is your spouse/partner currently receiving ${aishName.abbreviation}, ${adapName.abbreviation} or ${incomeSupportName.fullName} benefits?`,
    replacementLabel: `Is your <<replacementLabel>> currently receiving ${aishName.abbreviation}, ${adapName.abbreviation} or ${incomeSupportName.fullName} benefits?`,
    spousePartnerLabel: `Is your <<spouseLabel>> currently receiving ${aishName.abbreviation}, ${adapName.abbreviation} or ${incomeSupportName.fullName} benefits?`,
  },
  // consentSignatureRequired: {
  //   label: 'Please note that the signature of your spouse will be required on the consent and declaration form.',
  //   replacementLabel:
  //     'Please note that the signature of your <<replacementLabel>> will be required on the consent and declaration form.',
  // },
};
